module.exports = __webpack_public_path__ + "img/add.a9f09948.png";